/** @prettier */
import React from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp as FAIconName } from "@fortawesome/fontawesome-svg-core";

import "./ActionBar.css";

const ActionBar = ({ children }: { children: JSX.Element[] }) => (
    <div className="tr-actions">{children}</div>
);

const noop = () => {};
type ActionBarItemProps = {
    icon: FAIconName;
    active?: boolean;
    title: string;
    onClick?: () => void;
};
export const ActionBarItem = ({
    icon,
    active,
    onClick,
    title,
}: ActionBarItemProps) => (
    <button
        className={classNames("tr-action-bar-item", { active })}
        title={title}
        onClick={onClick || noop}
    >
        <FontAwesomeIcon icon={icon} size="lg" />
    </button>
);

ActionBar.Item = ActionBarItem;

export default ActionBar;
